<template>
  <el-dialog
    :title="sample.inspectionSampleId ? '编辑抽样' : '新增抽样'"
    :visible.sync="visible"
    width="720px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClose">
    <el-form
      ref="ruleForm"
      :model="sample"
      :rules="rules"
      label-width="130px">
      <el-divider>企业信息</el-divider>
      <el-form-item label="企业名称：">{{ sample.vendorName }}</el-form-item>
      <el-form-item label="证照号码：">{{ sample.unifiedCreditCode }}</el-form-item>
      <el-form-item label="联系人：">{{ sample.vendorPerson }}</el-form-item>
      <el-form-item label="联系号码：">{{ sample.vendorPhone }}</el-form-item>
      <el-divider>样品信息</el-divider>
      <el-form-item label="商品名称：">{{ sample.productName }}</el-form-item>
      <el-form-item
        label="产地："
        prop="originRegion">
        <el-input v-model="sample.originRegion"></el-input>
      </el-form-item>
      <el-form-item
        label="抽样区域："
        prop="sampleArea">
        <area-select v-model="sample.sampleArea"></area-select>
      </el-form-item>
      <el-form-item
        label="抽样地址："
        prop="sampleAddress">
        <el-input
          v-model="sample.sampleAddress"
          type="textarea"
          :rows="4"
          :autosize="{ minRows: 2, maxRows: 4}"></el-input>
      </el-form-item>
      <el-form-item
        label="样本数量："
        prop="sampleQuantity">
        <el-input-number
          v-model="sample.sampleQuantity"
          :min="0"
          :precision="0"></el-input-number>份
      </el-form-item>
      <el-form-item
        label="抽样费用："
        prop="sampleCost">
        <el-input-number
          v-model="sample.sampleCost"
          :min="0"
          :precision="2"></el-input-number>
      </el-form-item>
      <el-form-item
        label="是否赋码："
        prop="needSampling">
        <el-radio-group v-model="sample.needSampling">
          <el-radio-button :label="0">否</el-radio-button>
          <el-radio-button :label="1">是</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="抽样时间："
        prop="createdTime">
        <el-date-picker
          v-model="sample.createdTime"
          :editable="false"
          type="datetime"
          placeholder="选择日期时间">
        </el-date-picker>
      </el-form-item>
      <el-divider>生产信息</el-divider>
      <el-form-item
        label="进货/生产数量："
        prop="productionCount">
        <el-input v-model="sample.productionCount"></el-input>
      </el-form-item>
      <el-form-item
        label="进货/生产日期："
        prop="productionTime">
        <el-date-picker
          v-model="sample.productionTime"
          type="date"
          placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item
        label="产业园/市场："
        prop="industrialPark">
        <el-input v-model="sample.industrialPark"></el-input>
      </el-form-item>
      <el-form-item
        label="生产/供货商："
        prop="producer">
        <el-input v-model="sample.producer"></el-input>
      </el-form-item>
      <el-form-item
        label="生产/供货商地址："
        prop="producerAddress">
        <el-input v-model="sample.producerAddress"></el-input>
      </el-form-item>
      <el-form-item
        label="生产/供货商联系人："
        prop="producerPerson">
        <el-input v-model="sample.producerPerson"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">
        取 消
      </el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import AreaSelect from '../../sample-address/area-select.vue'
export default {
  name: 'SampleEditModal',
  components: { AreaSelect },
  props: {
    callback: {
      type: Function
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      sample: {
        inspectionSampleId: null,

        vendorId: null,
        vendorName: null,
        vendorPerson: '',
        vendorPhone: '',
        unifiedCreditCode: '',

        productId: null,
        productName: '',
        sampleArea: [],
        sampleAddress: '',
        originRegion: '', // 产地
        sampleQuantity: 1,
        sampleCost: 1,
        createdTime: null,
        needSampling: 0,

        productionCount: '',
        productionTime: null,
        industrialPark: '',
        producer: '',
        producerPerson: '',
        producerAddress: ''
      },
      rules: {
        vendorPerson: [
          { required: true, message: '请输入企业联系人', trigger: 'blur' }
        ],
        vendorPhone: [
          { required: true, message: '请输入企业联系号码', trigger: 'blur' }
        ],
        originRegion: [
          { required: true, message: '请输入产地', trigger: 'blur' }
        ],
        sampleArea: [
          { required: true, message: '请选择抽样区域', trigger: 'blur' }
        ],
        sampleAddress: [
          { required: true, message: '请输入抽样地址', trigger: 'blur' }
        ],
        sampleQuantity: [
          { required: true, message: '请选择样本数量', trigger: 'blur' }
        ],
        sampleCost: [
          { required: true, message: '请输入抽样费用', trigger: 'blur' }
        ],
        createdTime: [
          { required: true, message: '请输入抽样时间', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClose() {
      this.$refs.ruleForm.resetFields()
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const dispatch =
            this.sample.inspectionSampleId ? 'updatesample' : 'addsample'
          const [sampleProvinceCode, sampleCityCode, sampleAreaCode] = this.sample.sampleArea
          this.$store.dispatch(`account/${dispatch}`, {
            payload: {
              ...this.sample,
              sampleProvinceCode,
              sampleCityCode,
              sampleAreaCode
            },
            success: () => {
              this.loading = false
              this.toggleModal(false)
              this.callback && this.callback()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    init(vendor = {}, product = {}) {
      this.sample = {
        ...this.sample,
        ...vendor,
        ...product
      }
      this.toggleModal(true)
    }
  }
}
</script>
